import styled from 'styled-components';

export const Container = styled.header.attrs({
  className: 'sticky top-0 w-full z-10',
})``;
